export enum SOCKET_FOLDER_EVENT {
  /**
   * Event fired when a folder has been created
   */
  created = 'product_folders:created',

  /**
   * Event fired when a folder has been activated or deactivated
   */
  activated = 'product_folders:activated',
}
